export function getDisplayCompetitionName(
  competitionName: string | null | undefined,
  fallback = 'Match'
): string {
  const label = competitionName?.trim();
  if (!label) {
    return fallback;
  }

  if (/\bworld cup\b/i.test(label)) {
    return 'World Cup';
  }

  const withoutRestrictedPrefix = label
    .replace(/\bfifa\b/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
  return withoutRestrictedPrefix || fallback;
}

export function isLeagueCupCompetition(competitionName: string | null | undefined): boolean {
  const label = competitionName?.trim().toLowerCase() ?? '';
  return /\b(league cup|carabao cup|efl cup)\b/.test(label);
}

// Competitions whose fixtures always have a usable Match Detail page, even when
// the fixture is adopted under another tournament umbrella (matchDetailAvailable=false).
export function isMatchDetailSupportedCompetition(
  competitionName: string | null | undefined
): boolean {
  const label = competitionName?.trim().toLowerCase() ?? '';
  return /\b(fa cup|league cup|carabao cup|efl cup|champions league|europa league|conference league)\b/.test(
    label
  );
}
